import { render, staticRenderFns } from "./FormModEntrega.vue?vue&type=template&id=a51b6fb8&"
import script from "./FormModEntrega.vue?vue&type=script&lang=js&"
export * from "./FormModEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports